<div class="card">
    <div class="p-grid">
        <div class="p-col-2">
            <p><strong>Number: </strong></p>
            <p><strong>Channel: </strong></p>
            <p><strong>Account: </strong></p>
        </div>
        <div class="p-col-4">
            <p>{{receivePaymentDetail?.number }}</p>
            <p>{{receivePaymentDetail?.channelName }}</p>
            <p>{{receivePaymentDetail?.account?.businessName }}</p>
        </div>
        <div class="p-col-2">
            <p><strong>Date: </strong></p>
            <p><strong>Payment Method: </strong></p>
            <p><strong>Reference No: </strong></p>
        </div>
        <div class="p-col-4">
            <p>{{receivePaymentDetail?.receivedPaymentDate | localDate:'MM/DD/YYYY'}}</p>
            <p>{{receivePaymentDetail?.paymentMethod?.name}}</p>
            <p>{{receivePaymentDetail?.referenceNumber ? receivePaymentDetail?.referenceNumber : " "}}</p>
        </div>
    </div>
    <div class="p-grid">
        <div class="p-col-12">
            <p-table [value]="receivePaymentDetail?.receivedPaymentDetail">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Invoice No</th>
                        <th>Invoice Amount</th>
                        <th>Received Amount</th>
                        <th>Pending Amount</th>
                        <th>Applied Credit</th>
                        <th>WriteOff Amount</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-detail>
                    <tr>
                        <td>{{detail?.invoiceNumber}}</td>
                        <td>{{detail?.invoiceAmount | number: "1.2-2" | currencySymbol}}</td>
                        <td>{{detail?.invoiceReceivedAmount | number: "1.2-2" | currencySymbol}}</td>
                        <td>{{detail?.invoicePendingAmount | number: "1.2-2" | currencySymbol}}</td>
                        <td>{{detail?.appliedCredit | number: "1.2-2" | currencySymbol}}</td>
                        <td>{{detail?.writeOffAmount | number: "1.2-2" | currencySymbol}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<p-toast position="top-right" [baseZIndex]="10000"></p-toast>